export const formatPrice = (value, currency = "MXN", locale = "es-MX") => {
    return new Intl.NumberFormat(locale, {
        style: "currency",
        currency,
        minimumFractionDigits: 2,
    }).format(value);
};
